import type { IUserMilestone } from '../../IUserMilestone';

/**
 * Increment when retailer sees Showroom apparel categories C2 title banner
 * https:www.figma.com/file/nMAgBhL6oxN8dZr6zJxSAS/Showroom-v2?node-id=390%3A40725
 */
export const SHOWROOM_APPAREL_C2_TITLE_BANNER =
  'SHOWROOM_APPAREL_C2_TITLE_BANNER' as IUserMilestone.RetailerMilestone;
